import { legacy_connect as connect } from 'react-redux';

import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import {
  getActiveContentTab,
  getAllContentEntities,
} from '../../../store/selectors/content';
import content from '../../../store/slices/content';

import ContentTabs, { DispatchProps, StateProps } from './ContentTabs';

const mapStateToProps = (state: AppState): StateProps => ({
  entities: getAllContentEntities(state),
  activeTab: getActiveContentTab(state),
});

const mapDispatchToProps: DispatchProps = {
  onTabActivate: (id: UniqueId) => content.activate({ id }),
  onTabClose: (id: UniqueId) => content.close({ id }),
  onTabTogglePin: (id: UniqueId) => content.togglePin({ id }),
  onTabReorder: (fromIndex: number, toIndex: number) =>
    content.reorder({ fromIndex, toIndex }),
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentTabs);
